import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountGroupSchemaService } from './_account-group-schema.service';
import { ProductSchemaService } from './_product-schema.service';
import { SalesOrderSchemaService } from './_sales-order-schema.service';
import { TaskSchemaService } from './_task-schema.service';
import { IamSchemaService } from './_user-schema.service';
import {
  AbstractAuxiliaryDataSchemaService,
  FieldSchema,
  FieldSchemaIdentifier,
  GetFieldSchemaResponse,
  GetMultiFieldSchemaResponse,
  ListFieldSchemasResponse,
  ObjectType,
  UpdateFieldSchemaRequest,
  UpdateSchemaFieldMask,
} from './schema-interface';
import { ContactSchemaService } from './_contact_schema.service';

@Injectable({
  providedIn: 'root',
})
export class SchemaService {
  constructor(
    private readonly accountGroupSchemaService: AccountGroupSchemaService,
    private readonly usersFieldSchemaService: IamSchemaService,
    private readonly productFieldSchemaService: ProductSchemaService,
    private readonly salesOrderSchemaService: SalesOrderSchemaService,
    private readonly taskSchemaService: TaskSchemaService,
    private readonly contactSchemaService: ContactSchemaService,
  ) {}

  listFieldSchemas(
    objectType: ObjectType,
    partnerId: string,
    onlyArchived: boolean,
    cursor: string,
    pageSize: number,
  ): Observable<ListFieldSchemasResponse> {
    return this.selectService(objectType).listFieldSchemas(partnerId, onlyArchived, cursor, pageSize);
  }

  createFieldSchema(objectType: ObjectType, schema: FieldSchema): Observable<HttpResponse<null>> {
    return this.selectService(objectType).createFieldSchema(schema);
  }

  updateFieldSchema(
    objectType: ObjectType,
    changes: UpdateFieldSchemaRequest,
    fieldMask: UpdateSchemaFieldMask,
  ): Observable<HttpResponse<null>> {
    return this.selectService(objectType).updateFieldSchema(changes, fieldMask);
  }

  getFieldSchema(objectType: ObjectType, id: FieldSchemaIdentifier): Observable<GetFieldSchemaResponse> {
    return this.selectService(objectType).getFieldSchema(id);
  }

  getMultiFieldSchema(objectType: ObjectType, ids: FieldSchemaIdentifier[]): Observable<GetMultiFieldSchemaResponse> {
    return this.selectService(objectType).getMultiFieldSchema(ids);
  }

  archiveFieldSchema(objectType: ObjectType, id: FieldSchemaIdentifier): Observable<HttpResponse<null>> {
    return this.selectService(objectType).archiveFieldSchema(id);
  }

  unarchiveFieldSchema(objectType: ObjectType, id: FieldSchemaIdentifier): Observable<HttpResponse<null>> {
    return this.selectService(objectType).unarchiveFieldSchema(id);
  }

  private selectService(objectType: ObjectType): AbstractAuxiliaryDataSchemaService {
    switch (objectType) {
      case 'business':
        return this.accountGroupSchemaService;
      case 'user':
        return this.usersFieldSchemaService;
      case 'product':
        return this.productFieldSchemaService;
      case 'order':
        return this.salesOrderSchemaService;
      case 'task':
        return this.taskSchemaService;
      case 'Contact':
        return this.contactSchemaService;
      default:
        throw new Error('Unsupported object type');
    }
  }
}
